import "./About.css";
import AOS from "aos";
import { Store } from "../../Sections";
AOS.init({
  once: true,
});

const About = () => {
  return (
    <>
      <section className="about">
        <section className="about_img"></section>
        <Store />
      </section>
    </>
  );
};

export default About;
